export default __webpack_public_path__ + "static/media/ic_tail_arrow_right.fd902701.svg";